module.exports = __webpack_public_path__ + "img/logo_console_login@2x.d8b4408d.png";